import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';
import { callApp, getSchemeLink } from '@ifeng-fe/callapp';
import { WxLaunchApp } from 'ThreeTerminal_mobile_dynamic';
import { getShortVideoPraiseNum } from '../../../../services/api';
import styles from './index.css';
import candleIcon from '../../assets/candle.png';
import prayIcon from '../../assets/pray.png';

class OpenAppButton extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        isShowBar: true,
        isShowMask: false,
        praiseNum: '',
    };

    componentDidMount() {
        window.addEventListener('scroll', this.scrollHandle, false);
        this.getPraiseNum();
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.scrollHandle, false);
    }

    scrollHandle = () => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        const isShowBar = scrollTop <= 0;

        if (isShowBar !== this.state.isShowBar) {
            this.setState({
                isShowBar,
            });
        }
    };

    getPraiseNum = async () => {
        const { content = {} } = this.props;

        if (!content.base62Id) return;

        try {
            const praiseNum = await getShortVideoPraiseNum(content.base62Id);
            const formatPraiseNum = praiseNum && parseInt(praiseNum) && parseInt(praiseNum) >= 10 ? parseInt(praiseNum) : '';

            this.setState({
                praiseNum: formatPraiseNum,
            });
        } catch (e) {
            console.error(e);
        }
    };

    callAppHandle = (isJumpQQlink = false, isCallApp = true) => {
        const { content = {} } = this.props;
        const downloads = content.isVideoShare
            ? {}
            : {
                  download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1523710506194',
                  downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8967',
              };
        const client = content.isVideoShare ? 'videoApp' : 'newsApp';

        if (isCallApp) {
            callApp({
                client,
                docType: 'phvideo',
                pid: content._id,
                kind: 'inter_fxy13',
                download: downloads.download,
                downloadAd: downloads.downloadAd,
                isCopySchemeUrl: isJumpQQlink,
            });
        }
    };

    showMaskHandle = () => {
        this.setState({
            isShowMask: true,
        });
    };

    closeMaskHandle = () => {
        this.setState({
            isShowMask: false,
        });
    };

    renderWxLaunchApp = () => {
        const { content = {} } = this.props;
        const schemeLink = getSchemeLink({
            docType: 'phvideo',
            pid: content._id,
            kind: 'share01',
        });

        if (content.isVideoShare) return null;

        return (
            <WxLaunchApp
                launchType={'app'}
                launchAppClick={() => this.callAppHandle(false, false)}
                schemeLink={schemeLink}
                launchAppFail={() => this.callAppHandle(true, true)}
            />
        );
    };

    getLikeConfig = () => {
        const { content = {} } = this.props;
        const isCloseLike = content?.interact?.isCloseLike || false;
        const isOpenCandle = content?.interact?.isOpenCandle || false;
        const isOpenpray = content?.interact?.isOpenpray || false;

        if (isCloseLike && !isOpenCandle && !isOpenpray) {
            return {
                isShow: false,
            };
        }

        // 蜡烛
        if (isOpenCandle) {
            return {
                isShow: true,
                icon: candleIcon,
            };
        }

        // 祈祷
        if (isOpenpray) {
            return {
                isShow: true,
                icon: prayIcon,
            };
        }

        return {
            isShow: true,
        };
    };

    renderLikeButton = () => {
        const { praiseNum } = this.state;
        const likeConfig = this.getLikeConfig();

        if (!likeConfig.isShow) return null;

        return (
            <div className={styles.actionButton} title={praiseNum || '赞'} onClick={() => this.callAppHandle()}>
                {likeConfig.icon ? (
                    <img className={styles.likeImage} src={likeConfig.icon} />
                ) : (
                    <span className={styles.likeIcon} />
                )}
                {this.renderWxLaunchApp()}
            </div>
        );
    };

    render() {
        const { isShowBar, isShowMask } = this.state;

        return (
            <React.Fragment>
                <div className={`${styles.openAppBar} ${isShowBar ? styles.openAppBarShow : styles.openAppBarHide}`}>
                    <div className={styles.commentInput} onClick={() => this.callAppHandle()}>
                        打开APP参与讨论
                        {this.renderWxLaunchApp()}
                    </div>
                    <div className={styles.actionButton} onClick={() => this.callAppHandle()}>
                        <span className={styles.commentIcon} />
                        {this.renderWxLaunchApp()}
                    </div>
                    <div className={styles.actionButton} onClick={() => this.callAppHandle()}>
                        <span className={styles.collectIcon} />
                        {this.renderWxLaunchApp()}
                    </div>
                    {this.renderLikeButton()}
                    <div className={styles.wxButton} onClick={this.showMaskHandle}>
                        <span className={styles.wxIcon} />
                    </div>
                </div>
                {isShowMask && (
                    <div className={styles.wxMask} onClick={this.closeMaskHandle}>
                        <div className={styles.wxMaskTips} />
                    </div>
                )}
            </React.Fragment>
        );
    }
}

export default errorBoundary(OpenAppButton);
